//import views
import permission from "@/middlewares/permission";


function loadView( view ) {
    return () => import(`@/views/admin/users/${ view }.vue`);
}


const Index = loadView( 'Index' );
const View = loadView( 'View' );
const Logins = loadView( 'Logins' );

const userRoutes = [
    {
        path: 'users',
        name: 'api.users.getList',
        component: Index,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'users/:id',
        name: 'api.users.get',
        component: View,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'logins',
        name: 'api.auth.logins.getList',
        component: Logins,
        meta: {
            middleware: permission
        }
    },
];

export default userRoutes;
